import classNames from 'classnames';
import styles from './attributeTag.module.scss';

const AttributeTag = ({ className, attribute }) => (
  <div className={classNames(className, styles.attributeTag)}>
    <p className={styles.attributeName}>{attribute}</p>
  </div>
);

export default AttributeTag;
